import { ICatalogSectionBlock } from '@features/cms/typescript/index';
import styles from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionBlocks.styles';
import CatalogSectionRowBlock from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionRowBlocks';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
type PropsType = {
  data: ICatalogSectionBlock;
  defaultBackground?: string;
  isFirst?: boolean;
};
const CatalogSectionBlock = ({
  data,
  defaultBackground = undefined,
  isFirst = false
}: PropsType) => <section id={data.code} sx={styles.section(data?.blockAppearance?.background || defaultBackground || theme.rawColors.neutralWhite, data?.blockAppearance?.marginTop?.toString() || '0', data?.blockAppearance?.marginBottom?.toString() || '0')} data-cy={data.code} data-testid="catalog-section-blocks">
    {data.header && <Heading h={isFirst ? 1 : 2} headingType={2} pb={40} mobile>
        {data.header}
      </Heading>}
    {data.rows.length > 0 && data.rows.map((row, index) => {
    const key = `${row.layout}-${index}`;
    return <CatalogSectionRowBlock key={key} row={row} isFirst={isFirst && !index && !data.header} />;
  })}
  </section>;
export default CatalogSectionBlock;